module.exports = __webpack_public_path__ + "static/media/icon-tv-show.fc490d94.svg";